import React, { Component } from "react";
import { Grid, Form, Dropdown, Table } from "semantic-ui-react";
import PropTypes from "prop-types";
import TextControl from "./TextControl";
import CheckboxControl from "./CheckboxControl";

class InnerControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.control.value,
    };
  }
  componentDidMount() {}

  render() {
    let controls = [];
    controls = this.props.control.fields.map((field) => {
      const color = field.isMandatory ? "red" : "black";
      if (field.controlType === "text") {
        return (
          <TextControl
            key={field.controlId}
            control={field}
            onChange={this.props.onChange}
          />
        );
      } else if (field.controlType === "dropdown") {
        return (
          <Table.Cell key={`Inner_${field.controlId}`}>
            <Form.Field>
              <Dropdown
                fluid
                search
                selectOnBlur={false}
                selection
                id={field.controlId}
                options={field.options}
                name={field.controlName}
                placeholder={field.controlPlaceholder}
                defaultValue={this.state.value}
                label={field.controlLabel}
                onChange={this.props.onChange}
                style={{ color: { color } }}
              />
            </Form.Field>
          </Table.Cell>
        );
      } else if (field.controlType === "checkbox") {
        return (
          <CheckboxControl
            key={field.controlId}
            control={field}
            onChange={this.props.onChange}
          />
        );
      }
      return null;
    });

    return (
      <Grid.Row key={`drop_${this.props.control.controlId}`}>
        <Grid.Column>
          <Form.Field>
            <label htmlFor={this.props.control.controlLabel}>
              {this.props.control.controlLabel}
            </label>
          </Form.Field>
        </Grid.Column>
        <Grid.Column>
          <Table>
            <Table.Body>
              <Table.Row>{controls}</Table.Row>
            </Table.Body>
          </Table>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

InnerControl.propTypes = {
  control: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,
};

export default InnerControl;



// WEBPACK FOOTER //
// ./src/components/forms/controls/InnerControl.js